export default function TemplateImpressionConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('template.impression');
}

TemplateImpressionConfiguration.$inject = ['$translatePartialLoaderProvider'];
